import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "https",
  pure: true,
})
export class HttpsPipe implements PipeTransform {
  public transform(value: string) {
    return value.replace("http:", "https:");
  }
}



// WEBPACK FOOTER //
// ./src/pipes/https/https.ts